(function () {

  'use strict';

  function pxPowerPdfArguments() {
    return {
      restrict: 'EA',
      scope: {
      },
      templateUrl: 'app/components/softwareDistribution/powerPdfArguments/powerPdfArguments.template.html',
      link: function (scope) {
      }
    };
  }

  pxPowerPdfArguments.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxPowerPdfArguments', pxPowerPdfArguments);

})();
